











import Vue from 'vue'
import { setSort } from '../store/actions';
import { ISort, ITranslations } from '../store/state';
import { routerReplace } from '../helpers';

interface SortData {
}

interface SortMethods {
}

interface SortComputed {
    sorts: ISort[]
    sort: any,
	translations: ITranslations
}

export default Vue.extend<SortData, SortMethods, SortComputed , {}>({
	name: 'Sort',
    computed: {
        sorts() {
            return this.$store.getters.sorts
        },
        translations() {
			return this.$store.getters.translations
		},
        sort: {
            get() {
                const activeOption = this.$store.getters.sorts.find((s: any) => (s.active as any));
                return activeOption?.name;
            },
            set(value) {
                this.$store.dispatch(setSort(value))
                routerReplace({
                    query: this.$store.getters.getParams
                })
            }  
        }
    }
})
